module.exports = __webpack_public_path__ + "img/pingpong.b776e2a1.svg";